import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { InitialState, setArticleDataToStore } from "../../store/ArticleStore";
import { RootState } from "../../store/store";
import "./PopOverMenu.scss";

const PopOverMenu = ({ articleSlug }: { articleSlug: string }) => {
  const dispatch = useDispatch();
  const [copied, setCopied] = React.useState(false);

  const { articleData } = useSelector(
    (state: RootState) => state.articleStore as InitialState
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(
      window.location.origin + "/article/" + articleSlug
    );
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      dispatch(setArticleDataToStore([{ ...articleData[0], isShared: false }]));
    }, 3000);
  };

  const handleMail = () => {
    const subject = encodeURIComponent("Interessanter Artikel");
    const body = encodeURIComponent(
      `Hallo,\n\nich wollte diesen interessanten Artikel mit dir teilen: ${window.location.origin}/article/${articleSlug}\n\nViele Grüße!`
    );
    window.open(`mailto:?subject=${subject}&body=${body}`, "_blank");
      dispatch(setArticleDataToStore([{ ...articleData[0], isShared: false }]));
  };

  if (copied) {
    return (
      <div className="popover-menu not-italic flex-col flex text-gray-800">
        <div className="flex border-b-2 border-gray-200 p-1 m-1 ">
          <h3 className="text-lg text-center w-full font-bold">
            Link kopiert!
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div className="popover-menu not-italic flex-col flex text-gray-800">
      <div className="flex border-b-2 border-gray-200 p-1 m-1 ">
        <h3 className="text-lg text-center w-full font-bold">Artikel teilen</h3>
        <div
          className="cursor-pointer ml-auto "
          onClick={() =>
            dispatch(
              setArticleDataToStore([{ ...articleData[0], isShared: false }])
            )
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-x-icon lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </div>
      </div>

      <div className="flex flex-col gap-2 font-semibold">
        <button
          onClick={() => handleMail()}
          className="share-button-item h-fit gap-3 flex"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-mail-icon lucide-mail"
          >
            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
            <rect x="2" y="4" width="20" height="16" rx="2" />
          </svg>
          <h4 className="not-italic">Per E-Mail senden</h4>
        </button>

        <button
          onClick={() => handleCopy()}
          className="share-button-item h-fit gap-3 flex"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-link-icon lucide-link"
          >
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
          <h4 className="not-italic">Link in Zwischenablage kopieren</h4>
        </button>

        <button
          onClick={() =>
            dispatch(
              setArticleDataToStore([{ ...articleData[0], isShared: false }])
            )
          }
          className="share-button-item flex h-fit gap-3 mb-2 text-left text-blue-500 font-bold rounded-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-x-icon lucide-x"
          ></svg>
          <h4 className="not-italic">Abbrechen</h4>
        </button>
      </div>
    </div>
  );
};

export default PopOverMenu;
